/* ──────────────────────────────────────────────────────────────
 *  ConstraintDialog — Constraint achievement notice (D1)
 *
 *  Shown when the D1 sampling cannot satisfy a constraint.
 *  Reads the dynamic message from useUIStore.constraintPayload.
 *
 *  Ported from BushingApp.constraint_dialog (optibush.py).
 * ────────────────────────────────────────────────────────────── */

import React from 'react';
import Button from '@mui/material/Button';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

import DialogShell from '@/components/DialogShell';
import { useUIStore } from '@/stores/useUIStore';

const ConstraintDialog: React.FC = () => {
  const open = useUIStore((s) => s.constraintDialogOpen);
  const { message } = useUIStore((s) => s.constraintPayload);
  const closeDialog = useUIStore((s) => s.closeDialog);

  const handleClose = () => closeDialog('constraintDialog');

  return (
    <DialogShell
      open={open}
      onClose={handleClose}
      title="Constraint Achievement Notice"
      titleColor="warning.main"
      icon={<ReportProblemIcon color="warning" sx={{ fontSize: 28 }} />}
      maxWidth={550}
      actions={
        <Button variant="contained" color="info" onClick={handleClose}>
          OK
        </Button>
      }
    >
      {message}
    </DialogShell>
  );
};

export default ConstraintDialog;
